import { z } from 'zod';
/** Every caveat this report can raise. Keys, so both languages can carry them. */
export const EXTRACT_CAVEATS = [
    /**
     * The big one. server/src/services/import.ts stamps the UPLOADER as the
     * creator of every row an import creates, so one person committing a
     * spreadsheet appears to have personally typed thousands of clients. There
     * is no import_batch_id on company, contact or deal, so the rows cannot be
     * separated — only counted, from the batches themselves.
     */
    'imports',
    /**
     * No table anywhere records who UPDATED a row. Somebody whose month was
     * spent advancing deals, closing findings and chasing invoices produces
     * almost nothing here. The Edits sheet covers what the audit log reaches,
     * which is not everything.
     */
    'editsInvisible',
    /** Seeded demo data is attributed to the admin account. */
    'demoData',
    /** Rows entered then removed are included, and counted separately. */
    'removedIncluded',
    /**
     * This counts by when a record was ENTERED. The achievements report counts
     * follow-ups by when they HAPPENED and deals by who owns them, so the two
     * screens will not agree, and that is not a fault in either.
     */
    'differsFromAchievements',
];
// ------------------------------------------------------------------- query
/**
 * The extract's query.
 *
 * `userId` is REQUIRED, unlike the achievements report where it is an optional
 * filter — this report is about one named person and has no meaning without a
 * subject. Making it optional would quietly produce an extract of everybody,
 * which is a different and much larger thing.
 */
export const userEntryQuerySchema = z
    .object({
    from: z.string().date(),
    to: z.string().date(),
    userId: z.string().uuid(),
})
    .refine((v) => v.from <= v.to, {
    message: 'The start date must be on or before the end date',
    path: ['from'],
});
//# sourceMappingURL=userEntries.js.map